const Flickity = require('flickity');
// https://github.com/js-cookie/js-cookie
const Cookies = require('js-cookie');
require('flickity-imagesloaded');
require('flickity-fade');


class Gallery {

  fixSmallGalleries() {
    if (this.cellCount != 1) {
      this.hasDuplicates = true;
      // this.flickity.cells.forEach((cell) => {
      //   this.flickity.append($(cell.element).clone().removeClass('is-selected'));
      // });
      // this.flickity.cells.forEach((cell) => {
      //   this.flickity.append($(cell.element).clone().removeClass('is-selected'));
      // });
      // this.flickity.reloadCells();
    }
  }

  onSettle(index) {
  }

  onSelect(index) {
    window.clearTimeout(this.timeout);

    let currentIndex = index + 1;
    if (this.hasDuplicates) {
      currentIndex = (index % this.cellCount) + 1;
    }
    this.section.find('.count .current').text(currentIndex);

    this.slide = $(this.flickity.cells[index].element);

    // Check if the current slide has a video
    if (this.slide.hasClass('has-video')) {
      const videoEl = this.slide.find('.vimeo-video');
      const ID = videoEl.data('id');
      const duration = videoEl.data('duration') * 1000 - 500;

      // Pause any playing videos and reset the current video
      this.flickity.pausePlayer();
      this.isPaused = true;

      // Show the video element and add the fade-in class
      videoEl.css('display', 'block'); // Make it visible
      setTimeout(() => {
        videoEl.addClass('show'); // Trigger CSS transition
      }, 10); // Timeout to ensure the display change takes effect
      // Add the "show-image" class to the closest image with the "slide-image" class
      setTimeout(() => {
        this.slide.find('.slide-image').addClass('show-image');
      }, 1200);

      window.videos.forEach((element) => {
        element.video.resizeHelper();

        if (element.id == ID) {
          element.video.playVideo();
          this.timeout = window.setTimeout(() => {
            if (this.isPaused) {
              this.flickity.unpausePlayer();
              this.isPaused = false;
            }
            this.flickity.next();
          }, duration);
        } else {
          element.video.resetVideo();
        }
      });
    } else {
      // If no video, ensure it is hidden
      this.slide.find('.vimeo-video').css('display', 'none');
    }

    let caption = this.slide.data('caption');
    if (caption) {
      this.section.find('.caption').html(caption);
      this.section.addClass('has-caption');
    } else {
      this.section.find('.caption').html('');
      this.section.addClass('no-caption');
    }
  }


  onReady() {
    this.cellCount = this.flickity.cells.length;
    this.section.find('.count .total').text(this.cellCount);
    this.section.find('.arrow.next').click(() => {
      this.flickity.next();
    });
    this.section.find('.arrow.prev').click(() => {
      this.flickity.previous();
    });

    let $next = this.section.next();

    if ($next.hasClass('text-section')) {
      let metaHeight = this.section.find('.gallery-meta').outerHeight();
      let textHeight = $next.outerHeight(true);
      let textInner = $next.innerHeight();

      if (metaHeight > textHeight) {
        this.section.next().find('.container').css('min-height', metaHeight - (textHeight - textInner));
      }
    }

    let logic = () => {
      // clearTimeout(this.resumeTimeout);
      this.flickity.pausePlayer();
      this.isPaused = true;
      // this.resumeTimeout = setTimeout(() => {
      //   this.flickity.next();
      //   this.flickity.unpausePlayer();
      //   this.isPaused = false;
      // }, 10000);
    };
    this.section.find('.flickity-button').click(logic);
    this.section.find('.arrow').click(logic);
  }

  constructor(element, target, options) {
    let self = this;

    this.timeout = null;
    this.isPaused = false;
    this.el = $(element);
    this.section = $(element).parents(target);
    this.slides = this.el.find('.slide');

    // if (this.slides.hasClass('has-video')) {
    //   window.videos.forEach((element) => {
    //     element.video.player.on('loaded', (data) => {
    //       if (element.video.inGallery) {
    //         element.video.resizeHelper();
    //         element.video.resetVideo();
    //         // element.video.playVideo();
    //       }
    //     });
    //   });
    // }

    this.flickity = new Flickity(element, Object.assign({
      wrapAround: true,
      imagesLoaded: true,
      adaptiveHeight: true,
      setGallerySize: true,
      pageDots: false,
      fade: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      percentPosition: true,
      freeScroll: false,

      // prevNextButtons: $(element).find('img').length > 1 ? true : false,
      prevNextButtons: true,
      cellSelector: '.slide',
      on: {
        ready: function() {
          self.flickity = this;
          self.onReady();
        },
        change: function(index) {
        },
        settle: function(index) {
          self.slide = $(this.cells[index].element);
        },
        select: function(index) {
          // console.log('on select', index);
          self.flickity = this;
          self.onSelect(index);
        }
      }
    }, options));
  }
}








class NewFeaturedGallery {
  activateSlide(){

    let color = this.slide.data('color');
    $('body').removeClass('white-color-nav black-color-nav');
    $('body').addClass(color + '-color-nav');
    this.el.attr('data-color', color);

    let title = this.slide.data('title');
    let tagline = this.slide.data('tagline');
    let link = this.slide.data('link');
    this.section.find('.link').attr('href', link);
    this.section.find('.title').text(title);
    this.section.find('.tagline').text(tagline);

    setTimeout(function(){

    });
  }
  constructor(element){
    this.el = $(element);
    this.section = $(element).parents('');

    this.slide = this.el.find('.slide').eq(0).addClass('is-selected');

    this.activateSlide();
  }
}



class FeaturedGallery extends Gallery {
  onReady() {
    super.onReady();
  }

  onSelect(index) {
    super.onSelect(index);

    let title = this.slide.data('title');
    let tagline = this.slide.data('tagline');
    let link = this.slide.data('link');
    this.section.find('.link').attr('href', link);
    this.section.find('.title').text(title);
    this.section.find('.tagline').text(tagline);


    let color = this.slide.data('color');
    $('body').removeClass('white-color-nav black-color-nav');
    $('body').addClass(color + '-color-nav');
    this.el.attr('data-color', color);

    // let i = Cookies.get('gallery-index');

    // Cookies.set('gallery-index', index);
    // if (index !== 0) {
    //   Cookies.set('gallery-index', index);
    // }
  }

  constructor(element) {
    super(element,
      '.large-gallery', {
        cellAlign: 'left',
        adaptiveHeight: false,
        setGallerySize: false,
        draggable: false,
        prevNextButtons: false,
      });
  }
}


class FullScreenGallery extends Gallery {
  onReady() {
    super.onReady();
    this.fixSmallGalleries();
  }
  constructor(element) {
    super(element,
      '.large-gallery', {
        cellAlign: 'left',
        adaptiveHeight: false,
        setGallerySize: false
      });
  }
}

class InlineGallery extends Gallery {
  constructor(element) {
    super(element, '.inline-gallery', {});
  }
}

class SearchGallery extends Gallery {
  constructor(element) {
    super(element, '.search-gallery', {});
  }
}

module.exports = {
  Gallery,
  FullScreenGallery,
  NewFeaturedGallery,
  FeaturedGallery,
  SearchGallery,
  InlineGallery
};